
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季赛区">
<!--              <a-cascader :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛季赛区" v-model="queryParam.sjsq" changeOnSelect-->
<!--              />-->
              <a-cascader :show-search="{ sjsqFilter }" :options="sjsqOptions" :fieldNames="{ label: 'name', value: 'id', children: 'children' }" placeholder="请选择赛区" v-model="queryParam.sjsq" changeOnSelect />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item label="仅看执裁">
              <r-switch :formData="queryParam" field="zhicai" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="是" unCheckedChildren="否"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                        v-model="time_range_moment"
                        style="width: 100%"
                        format="YYYY-MM-DD HH:mm:ss"
                        :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>

        <div class="table-operator">

          <a-button icon="download" @click="downloadCertAll">批量下载</a-button>

          <a-button @click="download(1)" style="margin-left: 8px"  >
            申报裁判名单 <a-icon type="download" />
          </a-button>
          <a-button @click="download(2)" style="margin-left: 8px"  >
            执裁记录表 <a-icon type="download" />
          </a-button>
        </div>
      </a-form>
    </div>

    <div class="table-operator" >


    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999" v-if="record.start_title&&record.caipan_type">{{record.caipan_type}}</span>
          </div>
      </span>
      <span slot="youxiu" slot-scope="text,record">
              <r-switch :formData="record" @change="youxiuChange(record)" field="youxiu_status" :checkedValue="1" :unCheckedValue="0"
                        checkedChildren="是" unCheckedChildren="否"/>
      </span>
      <span slot="saiqu" slot-scope="text,record">
        {{record.saiqu_name}}
      </span>
      <span slot="status" slot-scope="text,record">
         {{record.current_index+1}}/{{record.duiwu_count}}
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a-dropdown v-if="record.start_title&&record.caipan_type"  >
            <a class="ant-dropdown-link">
              下载证书 <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item @click="downloadCert(record,0)">打印证书</a-menu-item>
              <!-- <a-menu-item @click="downloadCert(record,1)">带底图证书</a-menu-item> -->
            </a-menu>
          </a-dropdown>
        </template>
      </span>
    </s-table>

    <a-modal
            :maskClosable="false"
            :footer="null"
            title="批量下载"
            v-model="downloadAllShow"
    >
      <p v-show="taskInfo.doing">正在批量下载证书,请勿关闭或者刷新页面 <br/>
        <a-badge status="success" :text="'成功 '+(taskInfo.scount)"/>
        <a-divider type="vertical"/>
        <a-badge status="error" :text="'失败 '+(taskInfo.fcount)"/>
        <a-divider type="vertical"/>
        <a-badge status="processing" :text="'总数 '+(taskInfo.urls.length-1) "/>
      </p>
      <p v-show="!taskInfo.doing && downloadAllShow">
<!--        <a @click="createAllCert()">重新生成</a>-->
<!--        <a-divider type="vertical"/>-->
        <a @click="downloadCertMp()">批量下载</a>
      </p>
<!--      <p v-show="!taskInfo.doing && !certUrlDownload">-->
<!--        <a @click="createAllCert()">批量下载</a>-->
<!--      </p>-->
      <p>
        <a-progress v-show="taskInfo.doing" :percent="taskInfo.percent"/>
      </p>
    </a-modal>

  </a-card>
</template>

<style scoped>

  .ant-transfer .ant-transfer-list:first-child .footer-btn{display: none}
  .subject-transfer  /deep/ .is-visible {
    height: auto !important;
  }

</style>
<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import PicUploader from '@/components/PicUploader/'
  import RSwitch from '@/components/RSwitch/'
  import FileUploader from '@/components/FileUploader/'
  import areaOptions from '@/utils/area'
  import moment from 'moment'
  import setting from '@/config/setting'
  import UserPicker from '@/components/UserPicker/'
  import 'moment/locale/zh-cn';
  moment.locale('zh-cn');

  import {getCaipanList,sjsqOptions, downloadAllCpCert,setYouxiu} from '@/api/sai'
  import {doUrlTask} from '@/api/utils'

  export default {
    name: 'ScoreRun',
    components: {
      AInput,
      ATextarea,
      FileUploader,
      PicUploader,
      STable,
      EditableCell,
      UserPicker,
      RSwitch
    },
    data () {
      return {
        areaOptions,
        visible: false,
        sjsqOptions:[],
        saveLoading:false,
        saiqu:0,
        mingdanList:[
        ],
        mingdanTargetKeys:[],
        selectedMingdanKeys:[],
        scoreUserList:[],
        downloadAllShow: false,

        userVisible: false,

        userFormData: {
          user_id: undefined,
          type: undefined,
          name: undefined,
          start_id: 0
        },
        taskInfo: {
          urls: [],
          currentIndex: 0,
          scount: 0,
          fcount: 0,
          percent: 0,
          doing: false,
        },
        certUrlDownload: '',


        formData:{
          id:0,
        },
        time_range_moment:[],
        time_range:[],
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
//          xs: { span: 24 },
//          sm: { span: 8 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
          sjsq:[],
          status:2,
          zhicai:0
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '裁判信息',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            title: '赛区',
            dataIndex: 'saiqu',
            scopedSlots: { customRender: 'saiqu' +
            '' },
          },
          // {
          //   title: '优秀',
          //   dataIndex: 'youxiu_status',
          //   scopedSlots: { customRender: 'youxiu'},
          // },
          {
            title: '操作',
            dataIndex: 'action',
            fixed: 'right',
            width: 250,
            scopedSlots: { customRender: 'action' },
          }
        ],



        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          let that= this;

          if (this.time_range_moment[0] && this.time_range_moment[1]) {
            this.queryParam.time_range = [
              this.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),
              this.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')
            ]
          } else {
            this.queryParam.time_range = []
          }

          this.queryParam = Object.assign(this.queryParam,parameter);
          return getCaipanList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
      }
    },
    computed:{
    },
    created(){
    },

    mounted(){
      let that = this;
      that.getSjsqOptions();
    },
    methods: {
      moment,
      getSjsqOptions(){
        let that = this;
        sjsqOptions({}).then(res =>{
          that.sjsqOptions = res.data;
        });
      },
      handleCancel(){
        this.visible = false
      },
      //展开关闭
      toggleAdvanced() {
        this.advanced = !this.advanced
      },
      downloadCert(record,back){
        window.open(setting.apiBaseURL + '/wyhadminapi/sai/downloadCpCert?score_caipan_id=' + record.score_caipan_id+'&back='+back);
      },

      // 批量下载
      downloadCertAll() {
        let that = this;

        if(that.queryParam.sjsq.length !=2){
          that.$message.error('请先选择赛季赛区');
          return ;
        }
        that.downloadAllShow = true

        downloadAllCpCert({
          saiqu: that.queryParam.sjsq[1],
        }).then(res => {
          that.taskInfo = {
            urls: res.data,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            doing: true,
          }
          that.doTask(that.taskInfo);

        }).catch(err => {
          that.$message.error(err.data.msg);
        })
      },

      download(type){
        console.log('this.queryParam')
        console.log(this.queryParam)
        if(typeof this.queryParam.sjsq == 'undefined' || this.queryParam.sjsq.length !=2){
          this.$message.error('请先选择赛区');
          return ;
        }
        switch (type){
          case 1:
            window.open(setting.apiBaseURL+'/wyhadminapi/sai/caipanDownload?saiqu='+this.queryParam.sjsq[1]);
            break;

          case 2:
            window.open(setting.apiBaseURL+'/wyhadminapi/dscore/caipanDownload?saiqu='+this.queryParam.sjsq[1]);
            break;
        } 
      },
      createAllCert() {
        let that = this;
        downloadAllCpCert({
          saiqu: that.queryParam.sjsq[1],
        }).then(res => {
          that.taskInfo = {
            urls: res.data,
            currentIndex: 0,
            scount: 0,
            fcount: 0,
            doing: true,
          }
          that.doTask(that.taskInfo);

        }).catch(err => {
          that.$message.error(err.data.msg);
        })
      },

      doTask(taskInfo) {
        let that = this;
        if (taskInfo.currentIndex >= taskInfo.urls.length) {
          taskInfo.doing = false;
          return false;
        }
        doUrlTask({
          url: taskInfo.urls[taskInfo.currentIndex]
        }).then(res => {
          taskInfo.scount++;
          taskInfo.currentIndex++;
          console.log(taskInfo.currentIndex);
          if (taskInfo.currentIndex == (taskInfo.urls.length)) {
            that.certUrlDownload = res.data

            // that.downloadAllShow = false
            that.downloadCertMp()
          }
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
          that.doTask(taskInfo)
        }).catch(err => {
          taskInfo.fcount++;
          taskInfo.currentIndex++;
          taskInfo.percent = (((taskInfo.currentIndex) / taskInfo.urls.length) * 100).toFixed(1);
          that.doTask(taskInfo)
        });
      },

      downloadCertMp() {
        window.open(setting.apiBaseURL + this.certUrlDownload + '?_m=' + Math.random());
      },


      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      youxiuChange(record){
        setYouxiu({
          id:record.id,
          youxiu_status:record.youxiu_status
        }).then(res =>{ 
        });
      },

      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      sjsqFilter(inputValue, path) {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
      },
    },
    filters:{
    },
    watch: {
    }
  }
</script>
